// src/App.tsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { SnackbarProvider } from "notistack";
import Layout from "./components/Layout/Layout";
import Login from "./components/Auth/Login";
import NewsList from "./components/News/NewsList";
import NewsForm from "./components/News/NewsForm";
import NewsCategoryList from "./components/News/NewsCategoryList";
import GroupedNewsList from "./components/News/GroupedNewsList";
import PodcastList from "./components/Podcast/PodcastList";
import PodcastForm from "./components/Podcast/PodcastForm";
import SettingsForm from "./components/Settings/SettingsForm";
import PrivateRoute from "./components/PrivateRoute";
import PodcastTypeList from "./components/PodcastType/PodcastTypeList";
import PodcastTypeForm from "./components/PodcastType/PodcastTypeForm";
import PodcastEpisodeForm from "./components/PodcastEpisode/PodcastEpisodeForm";
import PodcastEpisodeList from "./components/PodcastEpisode/PodcastEpisodeList";
import Dashboard from "./components/Dashboard/Dashboard";
import NotFound from "./components/NotFound";
import theme from "./theme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
const SnackbarProviderItem = SnackbarProvider as any;
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProviderItem
          maxSnack={3}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              {/* <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Layout>
                      <Dashboard />
                    </Layout>
                  </PrivateRoute>
                }
              /> */}
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Layout>
                      <NewsList />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/news"
                element={
                  <PrivateRoute>
                    <Layout>
                      <NewsList />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/news/new"
                element={
                  <PrivateRoute>
                    <Layout>
                      <NewsForm />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/news/edit/:id"
                element={
                  <PrivateRoute>
                    <Layout>
                      <NewsForm />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/news/categories"
                element={
                  <PrivateRoute>
                    <Layout>
                      <NewsCategoryList />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/news/grouped"
                element={
                  <PrivateRoute>
                    <Layout>
                      <GroupedNewsList />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/podcasts"
                element={
                  <PrivateRoute>
                    <Layout>
                      <PodcastList />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/podcasts/new"
                element={
                  <PrivateRoute>
                    <Layout>
                      <PodcastForm />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/podcasts/edit/:id"
                element={
                  <PrivateRoute>
                    <Layout>
                      <PodcastForm />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/podcasts/:podcastId/episodes"
                element={
                  <PrivateRoute>
                    <Layout>
                      <PodcastEpisodeList />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/podcasts/:podcastId/episodes/new"
                element={
                  <PrivateRoute>
                    <Layout>
                      <PodcastEpisodeForm />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/podcasts/:podcastId/episodes/edit/:episodeId"
                element={
                  <PrivateRoute>
                    <Layout>
                      <PodcastEpisodeForm />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/podcast-types"
                element={
                  <PrivateRoute>
                    <Layout>
                      <PodcastTypeList />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/podcast-types/new"
                element={
                  <PrivateRoute>
                    <Layout>
                      <PodcastTypeForm />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/podcast-types/edit/:id"
                element={
                  <PrivateRoute>
                    <Layout>
                      <PodcastTypeForm />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute>
                    <Layout>
                      <SettingsForm />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
        </SnackbarProviderItem>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
